export default __webpack_public_path__ + "static/media/imageTum11.de7230e6.jpg";